import "./OtherIndustriesCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import CasestudyshowcaseCopy from "./sections/CasestudyshowcaseCopy";
import Footer from "@/reusable_sections/Footer";
export default function OtherIndustriesCaseStudyPage() {
  return <div>
      <Header />
      <Hero />
      <Casestudyshowcase />
      <CasestudyshowcaseCopy />
      <Footer />
    </div>;
}